import { Close } from "@mui/icons-material";
import { Grid, IconButton, Typography } from "@mui/material";
import { memo, useMemo } from "react";
import { MenuOptions } from "../CommonFilters/CommonFilterMenu";

type Props = {
  el: [string, string];
  options: Array<MenuOptions>;
  onClick: () => void;
};

const FilterView = ({ el, options, onClick }: Props) => {
  const text = useMemo(() => {
    const parent = options?.findIndex((option) => option.id === el[0]);
    const child = options[parent]?.options?.find(
      (option) => option.id === el[1],
    );
    return `${options[parent]?.title} : ${child?.title}`;
  }, [options, el]);
  return (
    <Grid
      container
      item
      gap={1}
      alignItems={"center"}
      flexWrap={"nowrap"}
      sx={{
        bgcolor: "#F0E9FC",
        px: 2,
        py: 0,
      }}
    >
      <Typography noWrap variant="body2" textTransform={"capitalize"}>
        {text}
      </Typography>
      <IconButton onClick={onClick}>
        <Close width={12} height={12}></Close>
      </IconButton>
    </Grid>
  );
};

export default memo(FilterView);
